import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Module, UserType } from "../../../Website/Types/Common/FeaturesBreakdown";
import { fetchUseCaseModules, fetchUseCaseUserTypes } from "../Thunks/WebsiteThunks";


interface WebsiteSliceState {
    loadingUseCaseUserTypes: boolean;
    useCaseUserTypes: UserType[];
    errorUseCaseUserTypes: string | null;

    loadingUseCaseModules: boolean;
    useCaseModules: Module[];
    errorUseCaseModules: string | null;
}

const initialState: WebsiteSliceState = {
    loadingUseCaseUserTypes: false,
    useCaseUserTypes: [],
    errorUseCaseUserTypes: null,

    loadingUseCaseModules: false,
    useCaseModules: [],
    errorUseCaseModules: null,
}

const websiteSlice = createSlice({
    name: "website",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        // fetch use case user types
        builder.addCase(fetchUseCaseUserTypes.pending, (state) => {
            state.loadingUseCaseUserTypes = true;
            state.errorUseCaseUserTypes = null;
        });
        builder.addCase(fetchUseCaseUserTypes.fulfilled, (state, action: PayloadAction<UserType[]>) => {
            state.loadingUseCaseUserTypes = false;
            state.useCaseUserTypes = action.payload;
        });
        builder.addCase(fetchUseCaseUserTypes.rejected, (state, action) => {
            state.loadingUseCaseUserTypes = false;
            state.errorUseCaseUserTypes = action.payload as string;
        });

        // fetch use case modules
        builder.addCase(fetchUseCaseModules.pending, (state) => {
            state.loadingUseCaseModules = true;
            state.errorUseCaseModules = null;
        });
        builder.addCase(fetchUseCaseModules.fulfilled, (state, action: PayloadAction<Module[]>) => {
            state.loadingUseCaseModules = false;
            state.useCaseModules = action.payload;
        });
        builder.addCase(fetchUseCaseModules.rejected, (state, action) => {
            state.loadingUseCaseModules = false;
            state.errorUseCaseModules = action.payload as string;
        });
    }
});

export default websiteSlice.reducer;